import React from 'react';
import { getDic } from '../../assets/i18n/dictionary';
import {
  FormRow,
  FormColumn,
  TextSmall,
} from '../../components';

const EmbedInstructions = (props) => {
  const {
    dimensions,
  } = props;

  const width = dimensions.width < 640 ? dimensions.width - 40 : 600;

  return (
    <FormRow justifyContent='center'>
      <FormColumn width={width} padding={10}>
        <FormRow>
          <TextSmall fontWeight='bold'>
            {`${getDic("face-collector-instrucoes-1")}:`}
          </TextSmall>
        </FormRow>
        <FormRow paddingTop={5}>
          <TextSmall>
            {`- ${getDic("face-collector-instrucoes-2")} https://face-recognition-app.sistemasinteegra.com.br/FaceCollector?public=true&eventId={EVENTOID}&system={SISTEMA}&guestId={PARTICIPANTEID}&attributeId={ATRIBUTOID}`}
          </TextSmall>
        </FormRow>
        <FormRow paddingTop={5}>
          <TextSmall>
            {`- ${getDic("face-collector-instrucoes-3")}`}
          </TextSmall>
        </FormRow>
        <FormRow paddingTop={5}>
          <TextSmall>
            {`- ${getDic("face-collector-instrucoes-4")}`}
          </TextSmall>
        </FormRow>
        <FormRow paddingTop={5}>
          <TextSmall>
            {`- ${getDic("face-collector-instrucoes-6")}`}
          </TextSmall>
        </FormRow>
        {/* <FormRow paddingTop={5}>
          <TextSmall>
            {`- OPCIONAL - A tag {ATRIBUTOID} é possível anviar o ID de um atributo do sistema para salvar a foto capturada.`}
          </TextSmall>
        </FormRow> */}
        <FormRow paddingTop={5}>
          <TextSmall>
            {`- ${getDic("face-collector-instrucoes-7")} {
              message: 'faceDetectionCollected',
              data: detectionData
            }`}
          </TextSmall>
        </FormRow>
      </FormColumn>
    </FormRow>
  )
};

export default EmbedInstructions;
